import { message } from '$/components/Message';
import { notifyRequestNetworkErrorOnce } from '../utils/resolveRequestErrorMessage';

/**
 * 请求失败时在拦截器层弹出断网提示，并标记错误避免重复 toast。
 */
export function createRequestErrorMiddleware() {
  return {
    onError: (error: unknown) => {
      notifyRequestNetworkErrorOnce(error, (key) => message.error(key));
    },
  };
}
